import { memo } from "react";

// Serializers
import BroadcastPostSerializer from "@/issara-sdk/types/BroadcastPostSerializer_apps_PRX";

type BroadcastStatusBadgeProps = {
  status: BroadcastPostSerializer["status"];
  label?: string;
};

const STATUS_STYLES: Record<
  BroadcastPostSerializer["status"],
  { backgroundColor?: string; color: string; textAlign: "center" | "left" }
> = {
  PENDING_REVIEW: { backgroundColor: "#e4e4e4", color: "#757575", textAlign: "center" },
  BROADCASTED: { backgroundColor: "#fcdbe5", color: "#e5436e", textAlign: "center" },
  REVIEW_REJECTED: { color: "#e5436e", textAlign: "left" },
  CANCELED: { color: "#e5436e", textAlign: "left" },
  DRAFTED: { color: "black", textAlign: "left" },
  REVIEWED: { color: "black", textAlign: "left" },
};

const BroadcastStatusBadge = ({ status, label }: BroadcastStatusBadgeProps) => {
  const style = STATUS_STYLES[status] || { color: "black", textAlign: "left" as const };

  return (
    <div
      style={{
        backgroundColor: style.backgroundColor,
        color: style.color,
        borderRadius: "4px",
        textAlign: style.textAlign,
        padding: "4px",
        width: "120px",
      }}
    >
      {label}
    </div>
  );
};

export default memo(BroadcastStatusBadge);
